export const countryList = [
  { name: "Afghanistan", iso_code: "AF", iso_639_1: "fa", flag: "🇦🇫" },
  { name: "Albania", iso_code: "AL", iso_639_1: "sq", flag: "🇦🇱" },
  { name: "Algeria", iso_code: "DZ", iso_639_1: "ar", flag: "🇩🇿" },
  { name: "American Samoa", iso_code: "AS", iso_639_1: "en", flag: "🇦🇸" },
  { name: "Andorra", iso_code: "AD", iso_639_1: "ca", flag: "🇦🇩" },
  { name: "Angola", iso_code: "AO", iso_639_1: "pt", flag: "🇦🇴" },
  { name: "Anguilla", iso_code: "AI", iso_639_1: "en", flag: "🇦🇮" },
  { name: "Antarctica", iso_code: "AQ", iso_639_1: "en", flag: "🇦🇶" },
  { name: "Antigua and Barbuda", iso_code: "AG", iso_639_1: "en", flag: "🇦🇬" },
  { name: "Argentina", iso_code: "AR", iso_639_1: "es", flag: "🇦🇷" },
  { name: "Armenia", iso_code: "AM", iso_639_1: "hy", flag: "🇦🇲" },
  { name: "Aruba", iso_code: "AW", iso_639_1: "nl", flag: "🇦🇼" },
  { name: "Australia", iso_code: "AU", iso_639_1: "en", flag: "🇦🇺" },
  { name: "Austria", iso_code: "AT", iso_639_1: "de", flag: "🇦🇹" },
  { name: "Azerbaijan", iso_code: "AZ", iso_639_1: "az", flag: "🇦🇿" },
  { name: "Bahamas", iso_code: "BS", iso_639_1: "en", flag: "🇧🇸" },
  { name: "Bahrain", iso_code: "BH", iso_639_1: "ar", flag: "🇧🇭" },
  { name: "Bangladesh", iso_code: "BD", iso_639_1: "bn", flag: "🇧🇩" },
  { name: "Barbados", iso_code: "BB", iso_639_1: "en", flag: "🇧🇧" },
  { name: "Belarus", iso_code: "BY", iso_639_1: "be", flag: "🇧🇾" },
  { name: "Belgium", iso_code: "BE", iso_639_1: "nl", flag: "🇧🇪" },
  { name: "Belize", iso_code: "BZ", iso_639_1: "en", flag: "🇧🇿" },
  { name: "Benin", iso_code: "BJ", iso_639_1: "fr", flag: "🇧🇯" },
  { name: "Bermuda", iso_code: "BM", iso_639_1: "en", flag: "🇧🇲" },
  { name: "Bhutan", iso_code: "BT", iso_639_1: "dz", flag: "🇧🇹" },
  { name: "Bolivia", iso_code: "BO", iso_639_1: "es", flag: "🇧🇴" },
  { name: "Bosnia and Herzegowina", iso_code: "BA", iso_639_1: "bs", flag: "🇧🇦" },
  { name: "Botswana", iso_code: "BW", iso_639_1: "en", flag: "🇧🇼" },
  { name: "Bouvet Island", iso_code: "BV", iso_639_1: "no", flag: "🇧🇻" },
  { name: "Brazil", iso_code: "BR", iso_639_1: "pt", flag: "🇧🇷" },
  { name: "British Indian Ocean Territory", iso_code: "IO", iso_639_1: "en", flag: "🇮🇴" },
  { name: "Brunei Darussalam", iso_code: "BN", iso_639_1: "ms", flag: "🇧🇳" },
  { name: "Bulgaria", iso_code: "BG", iso_639_1: "bg", flag: "🇧🇬" },
  { name: "Burkina Faso", iso_code: "BF", iso_639_1: "fr", flag: "🇧🇫" },
  { name: "Burundi", iso_code: "BI", iso_639_1: "rn", flag: "🇧🇮" },
  { name: "Cambodia", iso_code: "KH", iso_639_1: "km", flag: "🇰🇭" },
  { name: "Cameroon", iso_code: "CM", iso_639_1: "fr", flag: "🇨🇲" },
  { name: "Canada", iso_code: "CA", iso_639_1: "en", flag: "🇨🇦" },
  { name: "Cape Verde", iso_code: "CV", iso_639_1: "pt", flag: "🇨🇻" },
  { name: "Cayman Islands", iso_code: "KY", iso_639_1: "en", flag: "🇰🇾" },
  { name: "Central African Republic", iso_code: "CF", iso_639_1: "fr", flag: "🇨🇫" },
  { name: "Chad", iso_code: "TD", iso_639_1: "fr", flag: "🇹🇩" },
  { name: "Chile", iso_code: "CL", iso_639_1: "es", flag: "🇨🇱" },
  { name: "China", iso_code: "CN", iso_639_1: "zh", flag: "🇨🇳" },
  { name: "Christmas Island", iso_code: "CX", iso_639_1: "en", flag: "🇨🇽" },
  { name: "Cocos (Keeling) Islands", iso_code: "CC", iso_639_1: "en", flag: "🇨🇨" },
  { name: "Colombia", iso_code: "CO", iso_639_1: "es", flag: "🇨🇴" },
  { name: "Comoros", iso_code: "KM", iso_639_1: "ar", flag: "🇰🇲" },
  { name: "Congo", iso_code: "CG", iso_639_1: "fr", flag: "🇨🇬" },
  { name: "Cook Islands", iso_code: "CK", iso_639_1: "en", flag: "🇨🇰" },
  { name: "Costa Rica", iso_code: "CR", iso_639_1: "es", flag: "🇨🇷" },
  { name: "Cote D'Ivoire", iso_code: "CI", iso_639_1: "fr", flag: "🇨🇮" },
  { name: "Croatia", iso_code: "HR", iso_639_1: "hr", flag: "🇭🇷" },
  { name: "Cuba", iso_code: "CU", iso_639_1: "es", flag: "🇨🇺" },
  { name: "Cyprus", iso_code: "CY", iso_639_1: "el", flag: "🇨🇾" },
  { name: "Czech Republic", iso_code: "CZ", iso_639_1: "cs", flag: "🇨🇿" },
  { name: "Denmark", iso_code: "DK", iso_639_1: "da", flag: "🇩🇰" },
  { name: "Djibouti", iso_code: "DJ", iso_639_1: "fr", flag: "🇩🇯" },
  { name: "Dominica", iso_code: "DM", iso_639_1: "en", flag: "🇩🇲" },
  { name: "Dominican Republic", iso_code: "DO", iso_639_1: "es", flag: "🇩🇴" },
  { name: "East Timor", iso_code: "TP", iso_639_1: "pt", flag: "🇹🇱" },
  { name: "Ecuador", iso_code: "EC", iso_639_1: "es", flag: "🇪🇨" },
  { name: "Egypt", iso_code: "EG", iso_639_1: "ar", flag: "🇪🇬" },
  { name: "El Salvador", iso_code: "SV", iso_639_1: "es", flag: "🇸🇻" },
  { name: "Equatorial Guinea", iso_code: "GQ", iso_639_1: "es", flag: "🇬🇶" },
  { name: "Eritrea", iso_code: "ER", iso_639_1: "ti", flag: "🇪🇷" },
  { name: "Estonia", iso_code: "EE", iso_639_1: "et", flag: "🇪🇪" },
  { name: "Ethiopia", iso_code: "ET", iso_639_1: "am", flag: "🇪🇹" },
  { name: "Falkland Islands (Malvinas)", iso_code: "FK", iso_639_1: "en", flag: "🇫🇰" },
  { name: "Faroe Islands", iso_code: "FO", iso_639_1: "fo", flag: "🇫🇴" },
  { name: "Fiji", iso_code: "FJ", iso_639_1: "en", flag: "🇫🇯" },
  { name: "Finland", iso_code: "FI", iso_639_1: "fi", flag: "🇫🇮" },
  { name: "France", iso_code: "FR", iso_639_1: "fr", flag: "🇫🇷" },
  { name: "France, Metropolitan", iso_code: "FX", iso_639_1: "fr", flag: "🇫🇷" },
  { name: "French Guiana", iso_code: "GF", iso_639_1: "fr", flag: "🇬🇫" },
  { name: "French Polynesia", iso_code: "PF", iso_639_1: "fr", flag: "🇵🇫" },
  { name: "French Southern Territories", iso_code: "TF", iso_639_1: "fr", flag: "🇹🇫" },
  { name: "Gabon", iso_code: "GA", iso_639_1: "fr", flag: "🇬🇦" },
  { name: "Gambia", iso_code: "GM", iso_639_1: "en", flag: "🇬🇲" },
  { name: "Georgia", iso_code: "GE", iso_639_1: "ka", flag: "🇬🇪" },
  { name: "Germany", iso_code: "DE", iso_639_1: "de", flag: "🇩🇪" },
  { name: "Ghana", iso_code: "GH", iso_639_1: "en", flag: "🇬🇭" },
  { name: "Gibraltar", iso_code: "GI", iso_639_1: "en", flag: "🇬🇮" },
  { name: "Greece", iso_code: "GR", iso_639_1: "el", flag: "🇬🇷" },
  { name: "Greenland", iso_code: "GL", iso_639_1: "kl", flag: "🇬🇱" },
  { name: "Grenada", iso_code: "GD", iso_639_1: "en", flag: "🇬🇩" },
  { name: "Guadeloupe", iso_code: "GP", iso_639_1: "fr", flag: "🇬🇵" },
  { name: "Guam", iso_code: "GU", iso_639_1: "en", flag: "🇬🇺" },
  { name: "Guatemala", iso_code: "GT", iso_639_1: "es", flag: "🇬🇹" },
  { name: "Guinea", iso_code: "GN", iso_639_1: "fr", flag: "🇬🇳" },
  { name: "Guinea-bissau", iso_code: "GW", iso_639_1: "pt", flag: "🇬🇼" },
  { name: "Guyana", iso_code: "GY", iso_639_1: "en", flag: "🇬🇾" },
  { name: "Haiti", iso_code: "HT", iso_639_1: "fr", flag: "🇭🇹" },
  { name: "Heard and Mc Donald Islands", iso_code: "HM", iso_639_1: "en", flag: "🇭🇲" },
  { name: "Honduras", iso_code: "HN", iso_639_1: "es", flag: "🇭🇳" },
  { name: "Hong Kong", iso_code: "HK", iso_639_1: "zh", flag: "🇭🇰" },
  { name: "Hungary", iso_code: "HU", iso_639_1: "hu", flag: "🇭🇺" },
  { name: "Iceland", iso_code: "IS", iso_639_1: "is", flag: "🇮🇸" },
  { name: "India", iso_code: "IN", iso_639_1: "hi", flag: "🇮🇳" },
  { name: "Indonesia", iso_code: "ID", iso_639_1: "id", flag: "🇮🇩" },
  { name: "Iran (Islamic Republic of)", iso_code: "IR", iso_639_1: "fa", flag: "🇮🇷" },
  { name: "Iraq", iso_code: "IQ", iso_639_1: "ar", flag: "🇮🇶" },
  { name: "Ireland", iso_code: "IE", iso_639_1: "en", flag: "🇮🇪" },
  { name: "Israel", iso_code: "IL", iso_639_1: "he", flag: "🇮🇱" },
  { name: "Italy", iso_code: "IT", iso_639_1: "it", flag: "🇮🇹" },
  { name: "Jamaica", iso_code: "JM", iso_639_1: "en", flag: "🇯🇲" },
  { name: "Japan", iso_code: "JP", iso_639_1: "ja", flag: "🇯🇵" },
  { name: "Jordan", iso_code: "JO", iso_639_1: "ar", flag: "🇯🇴" },
  { name: "Kazakhstan", iso_code: "KZ", iso_639_1: "kk", flag: "🇰🇿" },
  { name: "Kenya", iso_code: "KE", iso_639_1: "sw", flag: "🇰🇪" },
  { name: "Kiribati", iso_code: "KI", iso_639_1: "en", flag: "🇰🇮" },
  { name: "North Korea", iso_code: "KP", iso_639_1: "ko", flag: "🇰🇵" },
  { name: "Korea, Republic of", iso_code: "KR", iso_639_1: "ko", flag: "🇰🇷" },
  { name: "Kuwait", iso_code: "KW", iso_639_1: "ar", flag: "🇰🇼" },
  { name: "Kyrgyzstan", iso_code: "KG", iso_639_1: "ky", flag: "🇰🇬" },
  { name: "Lao People's Democratic Republic", iso_code: "LA", iso_639_1: "lo", flag: "🇱🇦" },
  { name: "Latvia", iso_code: "LV", iso_639_1: "lv", flag: "🇱🇻" },
  { name: "Lebanon", iso_code: "LB", iso_639_1: "ar", flag: "🇱🇧" },
  { name: "Lesotho", iso_code: "LS", iso_639_1: "en", flag: "🇱🇸" },
  { name: "Liberia", iso_code: "LR", iso_639_1: "en", flag: "🇱🇷" },
  { name: "Libyan Arab Jamahiriya", iso_code: "LY", iso_639_1: "ar", flag: "🇱🇾" },
  { name: "Liechtenstein", iso_code: "LI", iso_639_1: "de", flag: "🇱🇮" },
  { name: "Lithuania", iso_code: "LT", iso_639_1: "lt", flag: "🇱🇹" },
  { name: "Luxembourg", iso_code: "LU", iso_639_1: "lb", flag: "🇱🇺" },
  { name: "Macau", iso_code: "MO", iso_639_1: "zh", flag: "🇲🇴" },
  { name: "Macedonia", iso_code: "MK", iso_639_1: "mk", flag: "🇲🇰" },
  { name: "Madagascar", iso_code: "MG", iso_639_1: "mg", flag: "🇲🇬" },
  { name: "Malawi", iso_code: "MW", iso_639_1: "en", flag: "🇲🇼" },
  { name: "Malaysia", iso_code: "MY", iso_639_1: "ms", flag: "🇲🇾" },
  { name: "Maldives", iso_code: "MV", iso_639_1: "dv", flag: "🇲🇻" },
  { name: "Mali", iso_code: "ML", iso_639_1: "fr", flag: "🇲🇱" },
  { name: "Malta", iso_code: "MT", iso_639_1: "mt", flag: "🇲🇹" },
  { name: "Marshall Islands", iso_code: "MH", iso_639_1: "en", flag: "🇲🇭" },
  { name: "Martinique", iso_code: "MQ", iso_639_1: "fr", flag: "🇲🇶" },
  { name: "Mauritania", iso_code: "MR", iso_639_1: "ar", flag: "🇲🇷" },
  { name: "Mauritius", iso_code: "MU", iso_639_1: "en", flag: "🇲🇺" },
  { name: "Mayotte", iso_code: "YT", iso_639_1: "fr", flag: "🇾🇹" },
  { name: "Mexico", iso_code: "MX", iso_639_1: "es", flag: "🇲🇽" },
  { name: "Micronesia, Federated States of", iso_code: "FM", iso_639_1: "en", flag: "🇫🇲" },
  { name: "Moldova, Republic of", iso_code: "MD", iso_639_1: "ro", flag: "🇲🇩" },
  { name: "Monaco", iso_code: "MC", iso_639_1: "fr", flag: "🇲🇨" },
  { name: "Mongolia", iso_code: "MN", iso_639_1: "mn", flag: "🇲🇳" },
  { name: "Montserrat", iso_code: "MS", iso_639_1: "en", flag: "🇲🇸" },
  { name: "Morocco", iso_code: "MA", iso_639_1: "ar", flag: "🇲🇦" },
  { name: "Mozambique", iso_code: "MZ", iso_639_1: "pt", flag: "🇲🇿" },
  { name: "Myanmar", iso_code: "MM", iso_639_1: "my", flag: "🇲🇲" },
  { name: "Namibia", iso_code: "NA", iso_639_1: "en", flag: "🇳🇦" },
  { name: "Nauru", iso_code: "NR", iso_639_1: "na", flag: "🇳🇷" },
  { name: "Nepal", iso_code: "NP", iso_639_1: "ne", flag: "🇳🇵" },
  { name: "Netherlands", iso_code: "NL", iso_639_1: "nl", flag: "🇳🇱" },
  { name: "Netherlands Antilles", iso_code: "AN", iso_639_1: "nl", flag: "🇦🇳" },
  { name: "New Caledonia", iso_code: "NC", iso_639_1: "fr", flag: "🇳🇨" },
  { name: "New Zealand", iso_code: "NZ", iso_639_1: "en", flag: "🇳🇿" },
  { name: "Nicaragua", iso_code: "NI", iso_639_1: "es", flag: "🇳🇮" },
  { name: "Niger", iso_code: "NE", iso_639_1: "fr", flag: "🇳🇪" },
  { name: "Nigeria", iso_code: "NG", iso_639_1: "en", flag: "🇳🇬" },
  { name: "Niue", iso_code: "NU", iso_639_1: "en", flag: "🇳🇺" },
  { name: "Norfolk Island", iso_code: "NF", iso_639_1: "en", flag: "🇳🇫" },
  { name: "Northern Mariana Islands", iso_code: "MP", iso_639_1: "en", flag: "🇲🇵" },
  { name: "Norway", iso_code: "NO", iso_639_1: "no", flag: "🇳🇴" },
  { name: "Oman", iso_code: "OM", iso_639_1: "ar", flag: "🇴🇲" },
  { name: "Pakistan", iso_code: "PK", iso_639_1: "ur", flag: "🇵🇰" },
  { name: "Palau", iso_code: "PW", iso_639_1: "en", flag: "🇵🇼" },
  { name: "Panama", iso_code: "PA", iso_639_1: "es", flag: "🇵🇦" },
  { name: "Papua New Guinea", iso_code: "PG", iso_639_1: "en", flag: "🇵🇬" },
  { name: "Paraguay", iso_code: "PY", iso_639_1: "es", flag: "🇵🇾" },
  { name: "Peru", iso_code: "PE", iso_639_1: "es", flag: "🇵🇪" },
  { name: "Philippines", iso_code: "PH", iso_639_1: "en", flag: "🇵🇭" },
  { name: "Pitcairn", iso_code: "PN", iso_639_1: "en", flag: "🇵🇳" },
  { name: "Poland", iso_code: "PL", iso_639_1: "pl", flag: "🇵🇱" },
  { name: "Portugal", iso_code: "PT", iso_639_1: "pt", flag: "🇵🇹" },
  { name: "Puerto Rico", iso_code: "PR", iso_639_1: "es", flag: "🇵🇷" },
  { name: "Qatar", iso_code: "QA", iso_639_1: "ar", flag: "🇶🇦" },
  { name: "Reunion", iso_code: "RE", iso_639_1: "fr", flag: "🇷🇪" },
  { name: "Romania", iso_code: "RO", iso_639_1: "ro", flag: "🇷🇴" },
  { name: "Russian Federation", iso_code: "RU", iso_639_1: "ru", flag: "🇷🇺" },
  { name: "Rwanda", iso_code: "RW", iso_639_1: "rw", flag: "🇷🇼" },
  { name: "Saint Kitts and Nevis", iso_code: "KN", iso_639_1: "en", flag: "🇰🇳" },
  { name: "Saint Lucia", iso_code: "LC", iso_639_1: "en", flag: "🇱🇨" },
  { name: "Saint Vincent and the Grenadines", iso_code: "VC", iso_639_1: "en", flag: "🇻🇨" },
  { name: "Samoa", iso_code: "WS", iso_639_1: "sm", flag: "🇼🇸" },
  { name: "San Marino", iso_code: "SM", iso_639_1: "it", flag: "🇸🇲" },
  { name: "Sao Tome and Principe", iso_code: "ST", iso_639_1: "pt", flag: "🇸🇹" },
  { name: "Saudi Arabia", iso_code: "SA", iso_639_1: "ar", flag: "🇸🇦" },
  { name: "Senegal", iso_code: "SN", iso_639_1: "fr", flag: "🇸🇳" },
  { name: "Seychelles", iso_code: "SC", iso_639_1: "en", flag: "🇸🇨" },
  { name: "Sierra Leone", iso_code: "SL", iso_639_1: "en", flag: "🇸🇱" },
  { name: "Singapore", iso_code: "SG", iso_639_1: "en", flag: "🇸🇬" },
  { name: "Slovak Republic", iso_code: "SK", iso_639_1: "sk", flag: "🇸🇰" },
  { name: "Slovenia", iso_code: "SI", iso_639_1: "sl", flag: "🇸🇮" },
  { name: "Solomon Islands", iso_code: "SB", iso_639_1: "en", flag: "🇸🇧" },
  { name: "Somalia", iso_code: "SO", iso_639_1: "so", flag: "🇸🇴" },
  { name: "South Africa", iso_code: "ZA", iso_639_1: "en", flag: "🇿🇦" },
  {
    name: "South Georgia &amp; South Sandwich Islands",
    iso_code: "GS",
    iso_639_1: "en",
    flag: "🇬🇸",
  },
  { name: "Spain", iso_code: "ES", iso_639_1: "es", flag: "🇪🇸" },
  { name: "Sri Lanka", iso_code: "LK", iso_639_1: "si", flag: "🇱🇰" },
  { name: "St. Helena", iso_code: "SH", iso_639_1: "en", flag: "🇸🇭" },
  { name: "St. Pierre and Miquelon", iso_code: "PM", iso_639_1: "fr", flag: "🇵🇲" },
  { name: "Sudan", iso_code: "SD", iso_639_1: "ar", flag: "🇸🇩" },
  { name: "Suriname", iso_code: "SR", iso_639_1: "nl", flag: "🇸🇷" },
  { name: "Svalbard and Jan Mayen Islands", iso_code: "SJ", iso_639_1: "no", flag: "🇸🇯" },
  { name: "Swaziland", iso_code: "SZ", iso_639_1: "en", flag: "🇸🇿" },
  { name: "Sweden", iso_code: "SE", iso_639_1: "sv", flag: "🇸🇪" },
  { name: "Switzerland", iso_code: "CH", iso_639_1: "de", flag: "🇨🇭" },
  { name: "Syrian Arab Republic", iso_code: "SY", iso_639_1: "ar", flag: "🇸🇾" },
  { name: "Taiwan", iso_code: "TW", iso_639_1: "zh", flag: "🇹🇼" },
  { name: "Tajikistan", iso_code: "TJ", iso_639_1: "tg", flag: "🇹🇯" },
  { name: "Tanzania, United Republic of", iso_code: "TZ", iso_639_1: "sw", flag: "🇹🇿" },
  { name: "Thailand", iso_code: "TH", iso_639_1: "th", flag: "🇹🇭" },
  { name: "Togo", iso_code: "TG", iso_639_1: "fr", flag: "🇹🇬" },
  { name: "Tokelau", iso_code: "TK", iso_639_1: "en", flag: "🇹🇰" },
  { name: "Tonga", iso_code: "TO", iso_639_1: "to", flag: "🇹🇴" },
  { name: "Trinidad and Tobago", iso_code: "TT", iso_639_1: "en", flag: "🇹🇹" },
  { name: "Tunisia", iso_code: "TN", iso_639_1: "ar", flag: "🇹🇳" },
  { name: "Turkey", iso_code: "TR", iso_639_1: "tr", flag: "🇹🇷" },
  { name: "Turkmenistan", iso_code: "TM", iso_639_1: "tk", flag: "🇹🇲" },
  { name: "Turks and Caicos Islands", iso_code: "TC", iso_639_1: "en", flag: "🇹🇨" },
  { name: "Tuvalu", iso_code: "TV", iso_639_1: "en", flag: "🇹🇻" },
  { name: "Uganda", iso_code: "UG", iso_639_1: "en", flag: "🇺🇬" },
  { name: "Ukraine", iso_code: "UA", iso_639_1: "uk", flag: "🇺🇦" },
  { name: "United Arab Emirates", iso_code: "AE", iso_639_1: "ar", flag: "🇦🇪" },
  { name: "United Kingdom", iso_code: "GB", iso_639_1: "en", flag: "🇬🇧" },
  { name: "United States", iso_code: "US", iso_639_1: "en", flag: "🇺🇸" },
  { name: "United States Minor Outlying Islands", iso_code: "UM", iso_639_1: "en", flag: "🇺🇲" },
  { name: "Uruguay", iso_code: "UY", iso_639_1: "es", flag: "🇺🇾" },
  { name: "Uzbekistan", iso_code: "UZ", iso_639_1: "uz", flag: "🇺🇿" },
  { name: "Vanuatu", iso_code: "VU", iso_639_1: "bi", flag: "🇻🇺" },
  { name: "Vatican City State (Holy See)", iso_code: "VA", iso_639_1: "it", flag: "🇻🇦" },
  { name: "Venezuela", iso_code: "VE", iso_639_1: "es", flag: "🇻🇪" },
  { name: "Viet Nam", iso_code: "VN", iso_639_1: "vi", flag: "🇻🇳" },
  { name: "Virgin Islands (British)", iso_code: "VG", iso_639_1: "en", flag: "🇻🇬" },
  { name: "Virgin Islands (U.S.)", iso_code: "VI", iso_639_1: "en", flag: "🇻🇮" },
  { name: "Wallis and Futuna Islands", iso_code: "WF", iso_639_1: "fr", flag: "🇼🇫" },
  { name: "Western Sahara", iso_code: "EH", iso_639_1: "ar", flag: "🇪🇭" },
  { name: "Yemen", iso_code: "YE", iso_639_1: "ar", flag: "🇾🇪" },
  { name: "Yugoslavia", iso_code: "YU", iso_639_1: "sr", flag: "🇷🇸" },
  { name: "Democratic Republic of Congo", iso_code: "CD", iso_639_1: "fr", flag: "🇨🇩" },
  { name: "Zambia", iso_code: "ZM", iso_639_1: "en", flag: "🇿🇲" },
  { name: "Zimbabwe", iso_code: "ZW", iso_639_1: "en", flag: "🇿🇼" },
];

export const getLangCodeFromLocation = (location) => {
  const found = countryList.find(
    (v) => v.iso_code.toLocaleLowerCase() === location.toLocaleLowerCase()
  );
  const [userLanguage] = (window.navigator.language || window.navigator.userLanguage).split("-");
  return (
    (found?.iso_639_1 && found.iso_639_1.toLocaleLowerCase()) ||
    userLanguage.toLocaleLowerCase() ||
    "en"
  );
};

export const stripeSupportedTransferCountries = [
  "AU",
  "AT",
  "BE",
  "BR",
  "BG",
  "CA",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GI",
  "GR",
  "HK",
  "HU",
  "IN",
  "IE",
  "IT",
  "JP",
  "LV",
  "LI",
  "LT",
  "LU",
  "MY",
  "MT",
  "MX",
  "NL",
  "NZ",
  "NO",
  "PL",
  "PT",
  "RO",
  "SG",
  "SK",
  "SI",
  "ES",
  "SE",
  "CH",
  "AE",
  "GB",
  "US",
];

export default { countryList, stripeSupportedTransferCountries };
